/**
 * @generated SignedSource<<e326d76220fea6499034136898e550b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Impulse",
    "kind": "LinkedField",
    "name": "updateImpulseNumber",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "number",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseImplNumberMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseImplNumberMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "37389b342082690b61d3243646ea44a6",
    "id": null,
    "metadata": {},
    "name": "ImpulseImplNumberMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseImplNumberMutation(\n  $request: UpdateImpulseNumberRequestInput\n) {\n  updateImpulseNumber(request: $request) {\n    id\n    number\n    version\n  }\n}\n"
  }
};
})();

node.hash = "97fe79df547b4426d537dbe0bbf23340";

module.exports = node;
